module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/power-phone-4.c1e16416.jpg";